import { render, staticRenderFns } from "./GenericTask.vue?vue&type=template&id=52988af9&scoped=true"
import script from "./GenericTask.vue?vue&type=script&lang=js"
export * from "./GenericTask.vue?vue&type=script&lang=js"
import style0 from "./GenericTask.vue?vue&type=style&index=0&id=52988af9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52988af9",
  null
  
)

export default component.exports